import { render } from "./Rate.vue?vue&type=template&id=733c9692"
import script from "./Rate.vue?vue&type=script&lang=ts"
export * from "./Rate.vue?vue&type=script&lang=ts"
script.render = render

export default script